<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime : 2019-12-25 15:16:40
 * @LastEditors  : Please set LastEditors
 -->
<template>
    <div id="page_Container">
        <div class="page">
            <!-- <navigation title="支付订单" :left-arrow="true"/> -->
            <div id="main-container" class="pay main-container">
                <div class="content">
                    <div class="amount">
                        ￥
                        <span>{{
                            ESVBase.numberTofixed(payParams.sumPayAmount)
                        }}</span>
                    </div>
                    <div class="ordernum">
                        <div class="orderBox clearfix">
                            <p class="pLeft">订单号:</p>
                            <p class="pRight">
                                <span
                                    v-for="(item, index) in orderList"
                                    :key="index"
                                    class="spanLast"
                                    >{{ item }}</span
                                >
                            </p>
                        </div>
                    </div>
                </div>
                <!-- 选择支付方式 -->
                <div class="payway">
                    <van-radio-group v-model="radio">
                        <van-cell-group>
                            <van-cell
                                v-for="(pItem, index) in payMethods"
                                :key="index"
                                :title="pItem.payMethod"
                                @click="choose(pItem, item, pItem.payCode)"
                            >
                                <van-radio :name="pItem.payCode" />
                                <img slot="icon" :src="pItem.payIcon" />
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>
                </div>
                <div class="returnbtn" @click="goPay">确认支付</div>
                <div class="cancelbtn" @click="cancelpay">取消支付</div>
            </div>
        </div>
    </div>
</template>
<script>
/* eslint-disable */
import { Toast } from 'vant';
import { toastLoading, clearToastLoading } from '@/utils/base/utils';

export default {
  data () {
    return {
      payParams: {
        sumPayAmount: ''
      },
      payMethods: [],
      radio: '',
      getPayResultCount: 0,
      remainderSnd: 60,
      qartIsShow: false,
      ajaxShow: false,
      orderList: [],
      payInfo: {},
      channelType: 'WECHAT',
      canBack: true
    };
  },
  esvReady: function () {
  },
  esvShow () {
    this.ESVStorage.getSessionValue('channelType', data => {
      this.channelType = data;
    });
    this.queryPay();
  },
  created () {
    document.title = '支付订单';
    this.ESVStorage.getSavedValue('orderInfo', data => {
      this.payParams = data;
      this.orderList = this.payParams.orderCode.split(',');
    });
  },
  beforeDestroy () {
    clearInterval(this.getPayResultInterval);
  },
  esvBack (backFn) {
    // 阻止系统返回键 
    if (this.channelType === 'APP') {
      backFn && backFn(this.canBack);
    } else {
      backFn && backFn(false);
    }
  },
  methods: {
    //通过订单号获取金额地址等数据
    queryData () {
      let ths = this;
      // ths.loading = true;
      ths.$doRequest(
        {
          url: '/order/prePayOrderQuery',
          params: {
            orderCode: ths.payParams.orderCode
          },
          before: function () {
            ths.loading = toastLoading();
          },
          complete: function () {
            clearToastLoading(ths.loading);
          }
        },
        function (data) {
          if (data.responseCode === '100000') {
            ths.payParams = data.result;
            ths.orderList = data.result.orderCode.split(',');
            ths.ajaxShow = true;
          } else {
            Toast(data.message);
          }
        }
      );
    },
    //获取支付方式
    queryPay () {
      let ths = this;
      this.$doRequest(
        {
          url: '/pay/queryPayMethod',
          params: {},
          before: function () {
            ths.loading = toastLoading();
          },
          complete: function () {
            clearToastLoading(ths.loading);
          }
        },
        function (data) {
          if (data.responseCode === '100000') {
            ths.payMethods = data.result;
            if (ths.payMethods.length === 1) {
              ths.radio = ths.payMethods[0].payCode;
              ths.$nextTick(ths.goPay)
            }
          } else {
            Toast(data.message);
          }
        }
      );
    },
    //选择支付方式
    choose (pItem, item, payCode) {
      this.radio = payCode;
    },
    //确认支付
    goPay () {
      this.canBack = false;
      let ths = this;
      let outletId = this.$route.params.outletId;
      if (!outletId) {
        this.ESVStorage.getSavedValue('__mall_cache_referralOutletId', data => {
          outletId = data
        })
        if (outletId) {
          this.ESVStorage.removeSavedValue('__mall_cache_referralOutletId')
        } else {
          outletId = ''
        }
      }
      // ths.loading = true;
      this.$doRequest(
        {
          url: '/pay/payment',
          params: {
            orderCodes: this.payParams.orderCode,
            payCode: this.radio,
            outletId
          },
          before: function () {
            ths.loading = toastLoading();
          },
          complete: function () {
            clearToastLoading(ths.loading);
          }
        },
        function (data) {
          ths.payInfo = data.result;
          if (ths.payInfo.resultCode === 'SUCCESS') {
            if (ths.channelType === 'APP') {
              console.log(ths.payInfo.h5PayUrl);
              let payUrlObj = { url: ths.payInfo.h5PayUrl };
              if (
                navigator.userAgent.indexOf('eslink-android') >
                -1
              ) {
                window.android.openUrl(
                  JSON.stringify(payUrlObj)
                );
              } else {
                if (window.webkit) {
                  window.webkit.messageHandlers.openUrl.postMessage(
                    payUrlObj
                  );
                }
              }

              ths.startQueryPayResult();
            } else {
                const channelType = ths.payInfo.tradePayChannelCode;
                if (channelType.indexOf('WECHAT') > -1) {
                    ths.payOnWechatApi();
                } else {
                    ths.redirectToPayPage(ths.payInfo);
                }
            }
          } else {
            ths.canBack = true;
            Toast('获取支付单失败');
          }
        }
      );
    },
    redirectToPayPage (payInfo) {
        const prepayCode = JSON.parse(payInfo.prepayCode);
        const payUrl = prepayCode.payUrl;
        if (payUrl) {
            this.ESVBaseUI.toast.show('正在跳转...', () => {
			    location.replace(payUrl);
			});
        } else {
            Toast(`支付渠道 ${payInfo.tradePayChannelCode} 未集成，或参数错误`);
        }
    },
    payOnWechatApi () {
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener(
            'WeixinJSBridgeReady',
            onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
          document.attachEvent(
            'onWeixinJSBridgeReady',
            onBridgeReady
          );
        }
      }
      this.loading = false;
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        eval('(' + this.payInfo.prepayCode + ')'),
        (res) => {
          // 查询后台结果
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            this.startQueryPayResult();
          } else {
            this.canBack = true;
          }
        }
      );
    },
    startQueryPayResult () {
      this.loading = toastLoading();

      this.getPayResultCount = 0;
      let ths = this;
      this.getPayResultInterval = setInterval(function () {
        ths.getPayResultCount++;
        if (ths.getPayResultCount > 60) {
          clearInterval(ths.getPayResultInterval);
          ths.getPayResultCount = 0;
          ths.canBack = true;
          clearToastLoading(ths.loading);
        } else {
          ths.getPayResult();
        }
      }, 1000);
    },
    // 得到支付结果
    getPayResult () {
      let ths = this;
      ths.$doRequest(
        {
          url: '/pay/queryPayResult',
          params: {
            mchOrderNo: ths.payInfo.mchOrderNo,
            transactionId: ths.payInfo.transactionId
          }
        },
        function (data) {
          if (
            data.result.resultCode === 'SUCCESS' &&
            data.result.tradePayState === 'SUCCESS'
          ) {
            clearInterval(ths.getPayResultInterval);
            clearToastLoading(ths.loading);
            ths.canBack = true;
            ths.esvOpenPage('OPPaysuccess');
          } else if (data.result.resultCode === 'FAIL') {
            clearInterval(ths.getPayResultInterval);
            clearToastLoading(ths.loading);
            Toast(data.result.errDesc);
            ths.canBack = true;
            ths.esvOpenPage('OPPayfail');
          }
        }
      );
    },
    // 取消支付
    cancelpay () {
      this.canBack = true;
      this.esvOpenPage({ name: 'OPMembercenter' });
    }
  }
};
</script>
<style lang="scss" scoped>
.pay {
    text-align: center;
    background-color: #f3f3f3;
    .content {
        // margin-top: 51px;
        padding-top: 12px;
        padding-bottom: 10px;
        text-align: center;
        color: #999;
        font-size: 14px;
        background: #ffffff;
        box-shadow: inset 0 -1px 0 0 #eeeeee;
        .time {
            color: #999;
            font-size: 20px;
            // margin-top: 26px;
        }
        .amount {
            color: $primary-color;
            margin: 10px 0 9px;
            span {
                color: $primary-color;
                font-size: 28px;
            }
        }
    }
    .payway {
        margin-top: 12px;
        .van-cell {
            align-items: center;
        }
        img {
            width: 25px;
            height: 20px;
            margin-right: 15px;
        }
    }
    .returnbtn {
        width: 87%;
        height: 44px;
        line-height: 44px;
        color: #fff;
        font-size: 14px;
        background: $primary-color;
        border-radius: 22px;
        margin: 26px auto 0;
    }
    .cancelbtn {
        width: 87%;
        height: 44px;
        line-height: 44px;
        color: #414141;
        font-size: 14px;
        border: 1px solid #414141;
        border-radius: 22px;
        margin: 10px auto 0;
    }
}
.van-cell {
    padding: 18px 0px;
    // margin: 0 16px;
    width: 90%;
    margin: 0 auto;
    border-bottom: 1px solid #e3e3e3;
}
.orderBox {
    margin: 0 auto;
    width: 250px;
    text-align: left;
    display: flex;
    // align-items: center;
}
.pLeft {
    float: left;
    margin-right: 10px;
}
.pRight {
    float: right;
    width: 190px;
    display: flex;
    flex-direction: column;
}
.spanLast {
    word-wrap: break-word;
    width: 100%;
}
</style>
